export enum ELogicalOperators {
  AND = 'AND',
  OR = 'OR',
}

export enum EComparisonOperators {
  EQUAL = 'EQ',
  NOT_EQUAL = 'NEQ',
  GREATER_THAN = 'GT',
  GREATER_THAN_OR_EQUAL = 'GTE',
  LESSER_THAN = 'LT',
  LESSER_THAN_OR_EQUAL = 'LTE',
  IN = 'IN',
  NOT_IN = 'NIN',
  STARTS_WITH = 'SW',
  ENDS_WITH = 'EW',
  CONTAINS = 'CON',
  NOT_CONTAINS = 'NCON',
}

export enum EComparisonOperatorsDisplayText {
  EQUAL_TO = 'Equal to',
  NOT_EQUAL_TO = 'Not equal to',
  GREATER_THAN = 'Greater than',
  LESSER_THAN = 'Less than',
  GREATER_THAN_OR_EQUAL_TO = 'Greater than or equal to',
  LESSER_THAN_OR_EQUAL_TO = 'Less than or equal to',
  IN = 'In',
  NOT_IN = 'Not in',
  STARTS_WITH = 'Starts with',
  ENDS_WITH = 'Ends with',
  CONTAINS = 'Contains',
  NOT_CONTAINS = 'Not contains',
}
